<template>
  <base-table>
    <thead>
      <tr>
        <th colspan="2">Drawdown Schedule</th>
        <th class="text-right" colspan="3">
          Total Drawdowns: <span :class="totalClass">{{ $formatting.toCurrency(total) }}</span>
        </th>
      </tr>
      <tr>
        <th>Description</th>
        <th>Date</th>
        <th>Amount</th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(drawdown, index) in loan.drawdowns" :key="index">
        <td>
          <base-input v-model="loan.drawdowns[index].description" placeholder="description" />
        </td>
        <td>
          <base-field addon-right-icon="calendar-alt" row>
            <base-input
              v-model="loan.drawdowns[index].date"
              :datepicker="{ minDate: startDate, maxDate: endDate }"

              placeholder="date" />
          </base-field>
        </td>
        <td>
          <base-field addon-left-icon="pound-sign" row>
            <base-input v-model="loan.drawdowns[index].amount" numeric placeholder="amount" />
          </base-field>
        </td>
        <td>
          <base-select v-model="loan.drawdowns[index].state" placeholder="state" source="drawdownState" />
        </td>
        <td>
          <div class="btn-group">
            <base-button v-tooltip="'Duplicate Drawdown'" icon-right="copy" small @click="duplicate(index)"/>
            <base-button v-tooltip="'Delete Drawdown'" icon-right="trash" small @click="remove(index)"/>
          </div>
        </td>
      </tr>
    </tbody>
  </base-table>
</template>

<script>
export default {
  name: 'FacilityDrawdown',

  props: {
    endDate: [Date, null],
    startDate: [Date, null],
    value: Object
  },

  data: () => ({
    loan: {}
  }),

  created () {
    this.assign()
  },

  computed: {
    total () {
      const amounts = []

      this.loan.drawdowns.map(drawdown => {
        amounts.push(this.$_.toNumber(drawdown.amount))
      })

      return this.$_.sum(amounts)
    },

    totalClass () {
      const amount = this.$_.toNumber(this.loan.amount)
      const total = this.total

      if (total > amount) {
        return 'text-danger'
      } else if (total < amount) {
        return 'text-muted'
      } else {
        return 'text-success'
      }
    }
  },

  methods: {
    assign () {
      this.loan = this.$_.cloneDeep(this.value)
    },

    duplicate (index) {
      const cloned = this.$_.cloneDeep(this.$_.omit(this.loan.drawdowns[index], [
        'id',
        'createdAt',
        'updatedAt'
      ]))
      this.loan.drawdowns.push(cloned)
    },

    remove (index) {
      this.$dialog.confirm('Are you sure you want to remove this draw down?', () => {
        this.loan.drawdowns.splice(index, 1)
      })
    }
  },

  watch: {
    loan: {
      deep: true,
      handler () {
        this.$emit('input', this.loan)
      }
    }
  }
}
</script>
